import CardRow from '../../components/CardRow/CardRow';
import CardRowCard from '../../components/CardRow/CardRowCard';
import FormWrapper from '../../components/CardRow/FormWrapper';
import React from 'react';
import TradingConfig from './components/TradingConfig';

const TradingConfigPage = () => {
  return (
    <>
      <FormWrapper>
        <CardRow>
          <CardRowCard>
            <TradingConfig />
          </CardRowCard>
        </CardRow>
      </FormWrapper>
    </>
  );
};

export default TradingConfigPage;
